import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageToggle from './LanguageToggle';
import { ThemeToggle } from '../ui/theme-toggle';

export default function AcademicNavigation() {
  const { t } = useLanguage();
  const location = useLocation();

  // 详情路由（如 /posts/:slug）也让对应分区保持高亮
  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <nav className="sticky top-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="text-lg font-medium text-foreground hover:text-primary transition-colors">
              zkb
            </Link>
            <div className="hidden md:flex space-x-6">
              <Link 
                to="/" 
                className={`text-sm font-medium transition-colors ${
                  isActive('/') ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {t('about')}
              </Link>
              <Link 
                to="/project" 
                className={`text-sm font-medium transition-colors ${
                  isActive('/project') ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {t('project')}
              </Link>
              <Link 
                to="/posts" 
                className={`text-sm font-medium transition-colors ${
                  isActive('/posts') ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {t('posts')}
              </Link>
              <Link 
                to="/cv" 
                className={`text-sm font-medium transition-colors ${
                  isActive('/cv') ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {t('cv')}
              </Link>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <ThemeToggle />
            <LanguageToggle />
          </div>
        </div>
      </div>
    </nav>
  );
}
